import { updateQueryParams } from "@catchoftheday/utilities";
export var routeToQueryParam = function routeToQueryParam(queryParams) {
  updateQueryParams({
    queryParams: queryParams,
    usePushState: true
  });
  globalThis.dispatchEvent(new Event("popstate"));
};